export default "__VITE_ASSET__DM3loBfp__"